// The department a results page starts filtered on. OGD people and the people of the project departments work on their own
// department's numbers, so a page with a Department filter opens on it (they can still pick "All departments"). Everyone else -
// Finance, HR, Top Management... - starts on all departments.
//
// Read from the login profile (profile.departmentId, saved at login), so it is known instantly: no request, no flash of the
// unfiltered table. The front-line departments are the ones the dashboard already limits to a person's own downline
// (RESTRICTED_DEPTS in src/warningDashboard/performanceMetricsScope.js on the server).
export const FRONT_LINE_DEPARTMENTS = [11, 3, 20, 21, 22, 30]; // OGD, Foundation, Classroom, Little Genie, Speak Pro, Open School

export const OGD_DEPARTMENT = 11;

// The viewer's department id from the same login profile, or null when it is not known (no login data, older session).
export const readViewerDepartmentId = () => {
  try {
    const id = Number(JSON.parse(localStorage.getItem('cred'))?.profile?.departmentId);
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
};

// OGD sells, it is not the CRO of a student, so the CRO Workflow section (leads waiting on a CRO) is empty for OGD staff:
// the landing page leaves it out for them. Unknown department = not OGD = the section stays (never hide on a guess).
export const isOgdViewer = () => readViewerDepartmentId() === OGD_DEPARTMENT;

export const readDefaultDepartment = () => {
  try {
    const id = Number(JSON.parse(localStorage.getItem('cred'))?.profile?.departmentId);
    return FRONT_LINE_DEPARTMENTS.includes(id) ? id : null;
  } catch {
    return null;
  }
};
